// Format a source URL for display: drop the protocol + leading "www.", keep the
// host + path (+ query), and trim a trailing slash. Shared so URL-ingested
// sources read the same way everywhere (the source picker, the site-capture
// import results, etc.). Kept dependency-free so it can be imported from any
// layer without circular-import risk.
export function formatSourceUrl(url) {
  if (!url || typeof url !== "string") return null;
  try {
    const u = new URL(url);
    const path = u.pathname === "/" ? "" : u.pathname.replace(/\/$/, "");
    return `${u.hostname.replace(/^www\./, "")}${path}${u.search || ""}`;
  } catch (e) {
    return url.replace(/^https?:\/\//, "").replace(/^www\./, "").replace(/\/$/, "");
  }
}
